
/**
 * 트윗 유형
 */
export type TrendListResponsePageAllOfThreeContentItemContentTweetsItemBasicInfoAllOfTwoTweetType = typeof TrendListResponsePageAllOfThreeContentItemContentTweetsItemBasicInfoAllOfTwoTweetType[keyof typeof TrendListResponsePageAllOfThreeContentItemContentTweetsItemBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendListResponsePageAllOfThreeContentItemContentTweetsItemBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
